import React from "react";
import AppRoutes from "app/routes";
import "styles/legacy/home.css";
import "styles/legacy/creator-content.css";
import "styles/legacy/sidebar.css";
import "styles/legacy/mobile-menu-items.css";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
